import { useMemo, useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { translate } from "app/filters/i18nFilter";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import { TechnologiesCategoryFilter } from "app/pages/sales-intelligence/modules/technology/components/TechnologiesCategoryFilter/TechnologiesCategoryFilter";
import type {
    CompanyAnalysisTechnologyItem,
    CompanyAnalysisTechnologyOption,
} from "app/pages/sales-intelligence/modules/technology/types/company-analysis-technology-filter";

import TechnologiesTableRow from "../TechnologiesTableRow/TechnologiesTableRow";

const TECHNOLOGIES_COUNT = 4;

const TechnologiesCardContent = ({ technologies }: { technologies: CompanyAnalysisTechnologyItem[] | undefined }) => {
    const [appliedCategories, setAppliedCategories] = useState<string[]>([]);
    const companyName = useCompanyName();

    const handleApplySelectedTechCategories = (categories: CompanyAnalysisTechnologyOption[]) => {
        setAppliedCategories(categories.map((item) => item.text));
        companyAnalysisTrackingService.widgets.trackTechnologiesFilterSelect(
            companyName,
            categories.map((item) => item.text).join(","),
        );
    };

    const filteredTechnologies = useMemo(() => {
        if (!technologies) {
            return [];
        }
        if (appliedCategories.length === 0) {
            return technologies;
        }
        return technologies.filter((technology) => appliedCategories.includes(technology.subCategory));
    }, [technologies, appliedCategories]);

    return (
        <>
            <TechnologiesCategoryFilter
                technologies={technologies}
                onDone={handleApplySelectedTechCategories}
            />
            <Flex
                width="100%"
                justifyContent="space-between"
                fontVariant="captionTitle"
                color={colorsPalettes.carbon[300]}
            >
                <span>{`${translate("si.company-analysis.technologies.card.header")} (${filteredTechnologies.length})`}</span>
                <Box width="80px">{translate("si.company-analysis.technologies.card.date")}</Box>
            </Flex>
            <Box margin="3px 0 0">
                {filteredTechnologies.slice(0, TECHNOLOGIES_COUNT).map((item) => (
                    <TechnologiesTableRow
                        key={item.technologyId}
                        item={item}
                    />
                ))}
            </Box>
        </>
    );
};

export default TechnologiesCardContent;
